<template>
  <div class="gov-course-detail" id="courseDetail">
    <div class="container">
      <div class="breadcrumb">
        <div
          class="flex"
          style="align-items: center; margin-bottom: 18px; padding-top: 18px"
        >
          <span style="font-size: 14px">当前位置：</span>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item
              style="cursor: pointer"
              :to="{ name: 'talentService' }"
              >人才服务</el-breadcrumb-item
            >
            <el-breadcrumb-item
              style="cursor: pointer"
              :to="{ name: 'onlineCourseList' }"
              >课程列表</el-breadcrumb-item
            >
            <el-breadcrumb-item style="color: #009999"
              >课程详情</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
      </div>
      <div class="course-detail-top" v-loading="dataLoading">
        <div>
          <div
            class="course-image"
            :style="{
              backgroundImage: `url(${'https://static.zhuzaocloud.com' +
                courseBasicInfo.mobileLogo})`,
            }"
          ></div>
        </div>
        <div class="course-detail-top-right">
          <div class="course-detail-top-right-top">
            <div class="course-detail-top-right-top-title">
              {{ courseBasicInfo.name }}
            </div>
            <div class="course-detail-top-right-top-info">
              <div style="display: flex">
                <div style="width: 60px; text-align: center">浏览量</div>
                <div
                  style="
                    width: 60px;
                    text-align: center;
                    border-left: 1px solid #ddd;
                  "
                >
                  购买量
                </div>
              </div>
              <div style="display: flex; padding-top: 5px">
                <div style="width: 60px; text-align: center">
                  {{ courseBasicInfo.viewcount }}
                </div>
                <div
                  style="
                    width: 60px;
                    text-align: center;
                    border-left: 1px solid #ddd;
                  "
                >
                  {{ courseBasicInfo.playcount }}
                </div>
              </div>
            </div>
          </div>
          <div class="course-detail-top-right-middle">
            <!-- <div style="margin-top: 17px; display: flex">
              <div>评分：</div>
              <div v-if="Math.floor(courseBasicInfo.lessionnum) === scores" style="display: flex">
                <div v-for="item in Math.floor(courseBasicInfo.lessionnum)" :key="item">
                  <div class="course-score-box"></div>
                </div>
              </div>
              <div v-else style="display: flex">
                <div v-for="item in Math.floor(courseBasicInfo.lessionnum)" :key="item" style="margin-top: 3px">
                  <div class="course-score-box"></div>
                </div>
                <div v-for="item in 5 - Math.floor(courseBasicInfo.lessionnum)" :key="item" style="margin-top: 3px">
                  <div class="course-null-icon-box"></div>
                </div>
              </div>
              <div>{{ courseBasicInfo.lessionnum }}</div>
            </div> -->
            <div style="margin-top: 15px; display: flex">
              <div>课时:</div>
              <div style="margin-left: 10px">
                {{ courseBasicInfo.loseTime }}课时
              </div>
            </div>
            <div style="margin-top: 15px; display: flex">
              <div>课程价格：</div>
              <!-- <div>¥{{ courseBasicInfo.sourceprice }}</div> -->
              <div style="color:#2d50a1">免费</div>
            </div>
            <div style="margin-top: 15px; display: flex;white-space:nowrap">
              <div>有效期：</div>
              <div>{{ courseBasicInfo.addtime | dateFormat }}</div>
              <div style="white-space:pre-wrap">-</div>
              <div>{{ courseBasicInfo.updateTime | dateFormat }}</div>
            </div>
          </div>
          <div class="course-detail-top-right-bottom">
            <div>
              <!-- v-if="courseBasicInfo.sourceprice === 0" -->
              <el-button
                type="primary"
                @click="
                  toViewVideo(
                    courseBasicInfo.id,
                    courseCatalogue.childKpoints[0].id,
                    courseCatalogue.childKpoints[0].name
                  )
                "
                >免费观看</el-button
              >
              <!-- <el-button
                type="primary"
                @click="
                  toViewVideo(
                    courseBasicInfo.sourceprice,
                    courseCatalogue.childKpoints[0].id
                  )
                "
                v-else
                >付费观看</el-button
              > -->
            </div>
          </div>
        </div>
      </div>
      <div
        :class="
          params.toShowWhich === '0'
            ? 'course-detail-bottom-select'
            : 'course-detail-bottom-normal'
        "
      >
        <div>
          <div style="height: 20px; display: flex;margin-left: 13px">
            <div
              @click="changeToShow('0')"
              style="border-right: 1px solid #2d50a1;"
              class="btn-common"
              :class="
                params.toShowWhich === '0' ? 'btn-txt-select' : 'btn-txt-normal'
              "
            >
              课程介绍
            </div>
            <div
              @click="changeToShow('1')"
              class="btn-common"
              :class="
                params.toShowWhich === '1' ? 'btn-txt-select' : 'btn-txt-normal'
              "
              style="margin-left: 20px;"
            >
              课程目录
            </div>
          </div>
          <div style="margin-left: 13px;">
            <div class="editer-box" v-if="params.toShowWhich === '0'">
              <div v-html="courseBasicInfo.context"></div>
            </div>
            <div v-else-if="params.toShowWhich === '1'">
              <div style="width:1260px;margin-top:20px">
                <el-collapse accordion v-model="activeName">
                  <el-collapse-item name="0">
                    <template slot="title">
                      {{ courseCatalogue.name }}
                    </template>
                    <div
                      v-for="(item, index) in courseCatalogue.childKpoints"
                      :key="index"
                    >
                      <div class="list-item-out-box">
                        <div class="item-out-border-left-box">
                          <div class="item-innner-border-left-box"></div>
                        </div>
                        <div class="item-innner-border-right-box">
                          <div
                            class="item-innner-text-box"
                            @click="
                              toViewVideo(
                                courseBasicInfo.id,
                                item.id,
                                item.name
                              )
                            "
                          >
                            <div class="item-innner-text-triangle-box"></div>
                            <div class="item-innner-text-catalogue-box">
                              第{{
                                item.sort < 10
                                  ? "0".concat("", item.sort - 1)
                                  : item.sort - 1
                              }}讲：{{ item.name }}
                            </div>
                          </div>
                          <div class="item-innner-text-right-box">
                            <div class="el-icon-video-camera-solid"></div>
                            <div class="course-duration">
                              {{ item.courseMinutes }}分&nbsp;{{
                                item.courseSeconds
                              }}秒
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCourseDetail } from "../../utils/interface"
export default {
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        {
          // set meta
          name: "keywords",
          content: this.metaKeywords,
        },
        {
          // set meta
          name: "description",
          content: this.metaDescription,
        },
      ],
    }
  },

  data() {
    return {
      params: {
        current: 1,
        pageSize: 20,
        total: 5,
        stage: "",
        toShowWhich: "0",
      },

      scores: 4.5,
      coursePrice: "0.00",
      validityPeriod: "此课程不支持退款，有效期两年，有效期内可反复观看",

      classHour: "1",

      description: "",

      courseName: "管理之理：生产运营之道",
      courseListItems: [
        {
          title: "先导篇：",
          name: "管理“理什么？",
          isFree: "免费观看",
          time: "16分 58秒",
        },
        {
          title: "第一讲：",
          name: "生产制造有没有钱赚？",
          isFree: "免费观看",
          time: "13分 58秒",
        },
      ],

      courseBasicInfo: null,
      courseCatalogue: null,

      content: "",

      curCourseId: "",
      dataLoading: true,
      activeName: ["0"],

      metaTitle: "",
      metaKeywords: "数字化| 数字化课程 | 数字化转型课程 |工业企业数字化转型课程 |企业培训",
      metaDescription: "专注于企业数字化转型课程的内容，帮助中小企业实现数字化转型升级。拥有丰富的课程资源、讲师资源，提供企业线上培训、新员工培训、在线培训考试、企业内训等服务，助力工业企业智能数字化转型。",
    }
  },
  created() {
    this.getParams()
    window.scrollTo(0, 100)
  },
  filters: {
    dateFormat(str) {
      if (str) {
        return str.split(" ")[0]
      } else {
        return
      }
    },
  },
  methods: {
    getParams() {
      this.curCourseId = this.$route.query.courseId
      this.getDetailByUuid()
    },
    getDetailByUuid() {
      this.dataLoading = true
      let api = getCourseDetail
      api(this.curCourseId)
        .then((res) => {
          if (res.data) {
            this.dataLoading = false
            this.courseBasicInfo = res.data.course
            this.courseCatalogue = res.data.courseKpoints[0]
            this.metaTitle =res.data.course.name +"-人才服务-公共服务平台"
          }
        })
        .catch(() => {
          this.dataLoading = false
        })
    },
    toViewVideo(courseId, courseItemId, itemName) {
      // if (sourceprice === 0) {
      //   let routeData = this.$router.resolve({
      //     path: "/onlineCourseVideo",
      //     query: {
      //       courseItemId: courseItemId,
      //       type: "free",
      //       titleName: "在线精品课程详情",
      //       titleForm: "onlineCourseVideo",
      //     },
      //   })
      //   window.open(routeData.href, "_blank")
      // } else {
      //   this.$confirm("请先购买课程!", "提示", {
      //     confirmButtonText: "支付",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   }).then(() => {
      //     let routeData = this.$router.resolve({
      //       path: "/onlineCourseVideo",
      //       query: {
      //         courseItemId: courseItemId,
      //         type: "free",
      //         titleName: "在线精品课程详情",
      //         titleForm: "onlineCourseVideo",
      //       },
      //     })
      //     window.open(routeData.href, "_blank")
      //   })
      // }
      let routeData = this.$router.resolve({
        path: "/onlineCourseVideo",
        query: {
          courseId: courseId,
          courseItemId: courseItemId,
          itemName: itemName,
          type: "free",
          titleName: "在线精品课程详情",
          titleForm: "onlineCourseVideo",
        },
      })
      window.open(routeData.href, "_blank")
    },
    formatValue(str, num) {
      console.log('str.split("-")[num]:', str.split("-"))
      return str.split("-")[num]
    },
    changeToShow(val) {
      this.params.toShowWhich = val
    },
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      // console.log('图片上传', );
      var formData = new FormData()
      formData.append("file", file) //第一个file 后台接收的参数名
      let res = await single(formData)
      // console.log('上传成功', res);
      if (res.url) {
        Editor.insertEmbed(cursorLocation, "image", res.url)
        resetUploader()
      } else {
        alert("上传返回失败")
      }
    },
    // 校验文字显示方式
    verifyNew(val) {
      if (val === "licenseUrl") {
        if (!this.enterpriseCertificationForm.licenseUrl) {
          this.licenseUrlMessage = "请上传企业证件附件"
        } else {
          this.licenseUrlMessage = ""
        }
      }
      if (val === "name") {
        if (!this.enterpriseCertificationForm.name) {
          this.nameMessage = "请输入企业名称"
        } else {
          this.validNameMess()
        }
      }
      if (val === "creditCode") {
        if (!this.enterpriseCertificationForm.creditCode) {
          this.creditCodeMessage = "请输入统一社会信用代码"
        } else {
          this.validCodeMess()
        }
      }
      if (val === "enterpriseTypeUuid") {
        if (!this.enterpriseCertificationForm.enterpriseTypeUuid) {
          this.enterpriseTypeUuidMessage = "请选择企业类型"
        } else {
          this.enterpriseTypeUuidMessage = ""
        }
      }
      if (val === "corporation") {
        if (!this.enterpriseCertificationForm.corporation) {
          this.corporationMessage = "请输入法人"
        } else {
          this.corporationMessage = ""
        }
      }
      if (val === "registeredDate") {
        if (!this.enterpriseCertificationForm.registeredDate) {
          this.registeredDateMessage = "请选择成立时间"
        } else {
          this.registeredDateMessage = ""
        }
      }
      if (val === "registeredCapital") {
        if (!this.enterpriseCertificationForm.registeredCapital) {
          this.registeredCapitalMessage = "请输入注册资本"
        } else {
          this.registeredCapitalMessage = ""
        }
      }
      if (val === "contact") {
        if (!this.enterpriseCertificationForm.contact) {
          this.contactMessage = "请输入联系人"
        } else {
          this.contactMessage = ""
        }
      }
      if (val === "businessTerm") {
        if (!this.enterpriseCertificationForm.businessTerm) {
          this.businessTermMessage = "请选择营业期限"
        } else {
          this.businessTermMessage = ""
        }
      }
      if (val === "regionValue") {
        if (!this.regionValue) {
          this.regionValueMessage = "请选择注册地"
        } else {
          this.regionValueMessage = ""
        }
      }
      if (val === "address") {
        if (!this.enterpriseCertificationForm.address) {
          this.addressMessage = "请输入详细地址"
        } else {
          this.addressMessage = ""
        }
      }
      if (val === "contactMail") {
        if (!this.enterpriseCertificationForm.contactMail) {
          this.contactMailMessage = "请输入联系邮箱"
        } else {
          if (
            !this.validate.isEmail(this.enterpriseCertificationForm.contactMail)
          ) {
            this.contactMailMessage = "请输入正确的邮箱地址"
          } else {
            this.contactMailMessage = ""
          }
        }
      }
      if (val === "contactTel") {
        if (!this.enterpriseCertificationForm.contactTel) {
          this.contactTelMessage = "请输入联系电话"
        } else {
          if (
            !this.validate.isMobile(this.enterpriseCertificationForm.contactTel)
          ) {
            this.contactTelMessage = "请输入正确的联系电话"
          } else {
            this.contactTelMessage = ""
          }
        }
      }
      if (val === "empNum") {
        if (!this.enterpriseCertificationForm.empNum) {
          this.empNumMessage = "请输入员工人数"
        } else {
          this.empNumMessage = ""
        }
      }

      if (val === "businessScope") {
        if (!this.enterpriseCertificationForm.businessScope) {
          this.businessScopeMessage = "请输入经营范围"
        } else {
          this.businessScopeMessage = ""
        }
      }
      if (val === "products") {
        if (!this.enterpriseCertificationForm.products) {
          this.productsMessage = "请输入主营产品"
        } else {
          this.productsMessage = ""
        }
      }
      if (val === "description") {
        if (!this.enterpriseCertificationForm.description) {
          this.descriptionMessage = "请输入公司简介"
        } else {
          this.descriptionMessage = ""
        }
      }
      if (val === "webSite") {
        if (
          this.enterpriseCertificationForm.webSite &&
          !this.validate.isURL(this.enterpriseCertificationForm.webSite)
        ) {
          this.webSiteMessage =
            "请输入正确的企业网址,如https://www.shuibengcloud.com"
        } else {
          this.webSiteMessage = ""
        }
      }
    },
  },
}
</script>
<style scoped lang="less">
@basic-colors: #009999;

.gov-course-detail {
  // background: rgb(245 245 245);
  padding-top: 10px;
  background: rgb(245, 245, 245);

  /deep/.el-collapse {
    border: none;

    .el-collapse-item__header {
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      height: 29px;
      line-height: 48px;
      background-color: #fff;
      color: #555;
      cursor: pointer;
      border-bottom: none;
      font-size: 16px;
      font-weight: 500;
      transition: border-bottom-color 0.3s;
      outline: 0;
    }

    .el-collapse-item__header.is-active {
      background-color: #f8f8f8 !important;
    }

    .el-collapse-item__wrap {
      will-change: height;
      background-color: #fff;
      overflow: hidden;
      box-sizing: border-box;
      border-bottom: none;
      margin-left: 15px;
      border-left: 1px dotted #cccccc;
      padding-left: 16px;

      .el-collapse-item__content {
        padding-bottom: 0px;
        font-size: 14px;
        color: #555;
        line-height: 1.769230769230769;

        .list-item-out-box {
          // height: 31px;
          display: flex;
          align-items: flex-end;
          margin-top: 5px;
          margin-bottom: 5px;

          .item-out-border-left-box {
            border-left: 1px dotted #cccccc;
            height: 13px;
            display: flex;
            margin-bottom: 5px;
            overflow: hidden;

            .item-innner-border-left-box {
              border-bottom: 1px dotted #cccccc;
              margin-bottom: 6px;
              width: 10px;
            }
          }

          .item-innner-border-right-box {
            display: flex;
            justify-content: space-between;
            width: 1209px;
            align-items: flex-end;

            .item-innner-text-box {
              display: flex;
              cursor: pointer;

              .item-innner-text-triangle-box {
                width: 0px;
                height: 0;
                border-top: 6px solid transparent;
                border-right: 6px solid transparent;
                border-left: 6px solid #aeb2b6;
                border-bottom: 6px solid transparent;
                margin-top: 6px;
                margin-left: 16px;
              }

              .item-innner-text-catalogue-box {
                margin-left: 10px;
              }
            }

            .item-innner-text-right-box {
              display: flex;
              width: 83px;
              justify-content: space-between;
              align-items: flex-end;

              .el-icon-video-camera-solid {
                color: #8f8888;
                margin-bottom: 4px;
              }

              .course-duration {
                color: #bbbbbb;
              }
            }
          }
        }
      }
    }

    .el-collapse-item__arrow {
      width: 40px;
    }

    .el-icon-arrow-right:before {
      content: "+";
      font-size: 15px;
      font-family: "heiti";
      color: #000;
      font-weight: bold;
    }

    .el-collapse-item__arrow.is-active {
      transform: none;
    }

    .el-collapse-item__arrow.is-active::before {
      content: "-";
      font-size: 20px;
      font-family: "heiti";
      color: #000;
      font-weight: 600;
      margin-left: 1px;
    }
  }

  .container {
    width: 1300px;
    margin: 0 auto;
    // margin-top: 10px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 20px;

    .breadcrumb {
      width: 100%;
      margin: 0 auto;
      background: #ffffff;
      // margin-top: 10px;
      border-bottom: 1px solid #ccc;
    }

    .course-detail-top {
      height: 325px;
      display: flex;
      justify-content: space-around;
      padding-top: 20px;

      .course-image {
        width: 514px;
        height: 290px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .course-detail-top-right {
        width: 695px;

        .course-detail-top-right-top {
          height: 40px;
          display: flex;
          justify-content: space-between;

          .course-detail-top-right-top-title {
            width: 553px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            font-size: 22px;
            font-weight: 700;
          }

          .course-detail-top-right-top-info {
            color: #666;
          }
        }

        .course-detail-top-right-middle {
          color: #666;
          font-size: 14px;

          .course-score-box {
            background-image: url("../../assets/publicService/talentService/xx.png");
            width: 13px;
            height: 13px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }

          .course-null-icon-box {
            background-image: url("../../assets/publicService/talentService/hx.png");
            width: 13px;
            height: 13px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }

        .course-detail-top-right-bottom {
          display: flex;
          margin-top: 90px;

          /deep/ .el-button--primary {
            color: #fff;
            background-color: #2d50a1;
            border-color: #2d50a1;
            width: 200px;
          }
        }
      }
    }

    .course-detail-bottom-normal {
      display: flex;
      min-height: 200px;
      padding-bottom: 20px;
    }

    .course-detail-bottom-select {
      display: flex;

      .editer-box {
        margin-bottom: 20px;
        margin-top: 20px;
        font-size: 14px;
        color: #555;
      }
    }

    .btn-common {
      width: 85px;
      cursor: pointer;
      text-align: left;
    }

    .btn-txt-select {
      color: #2d50a1;
    }

    .btn-txt-normal {
      color: #000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/talentServices/onlineCourseDetail.vue